import { Component, computed, effect, input } from '@angular/core';

@Component({
  selector: 'app-gift-gradient',
  imports: [],
  template: `
    <svg class="w-full h-auto" width="75" height="53" viewBox="0 0 75 53" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g [attr.filter]="'url(#blur-' + uid + ')'">
        <path
          d="M37.0394 38.6614C12.8305 38.6614 -1.29136 22.5061 -5.32617 14.4285V63.8146H79.8891V14.4285C75.6929 22.5061 61.2483 38.6614 37.0394 38.6614Z"
          [attr.fill]="'url(#grad-' + uid + ')'" />
      </g>

      <defs>
        <filter
          [attr.id]="'blur-' + uid"
          x="-19.75"
          y="0"
          width="114.07"
          height="78.24"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="7.21425" />
        </filter>

        <linearGradient [attr.id]="'grad-' + uid" x1="37.28" y1="14.42" x2="37.28" y2="63.81" gradientUnits="userSpaceOnUse">
          <stop offset="0.502607" [attr.stop-color]="lightColor()" />
          <stop offset="0.781189" [attr.stop-color]="darkColor()" />
        </linearGradient>
      </defs>
    </svg>
  `,
  host: {
    class: 'absolute bottom-0 left-0 w-full h-auto -z-1 block',
  },
})
export class GiftGradientComponent {
  /** Base color (hex). Default: original SVG blue */
  color = input<any>('#53D4FF');
  uid = Math.random().toString(36).substring(2, 9);

  constructor() {
    effect(() => {
      console.log('color', this.color());
    });
  }

  /** Generate lighter/darker versions */
  private adjust = (hex: string, percent: number) => {
    const num = parseInt(hex.replace('#', ''), 16);
    let r = (num >> 16) + percent;
    let g = ((num >> 8) & 0x00ff) + percent;
    let b = (num & 0x0000ff) + percent;

    r = Math.min(255, Math.max(0, r));
    g = Math.min(255, Math.max(0, g));
    b = Math.min(255, Math.max(0, b));

    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
  };

  /** Light color → +5% */
  lightColor = computed(() => this.adjust(this.color(), 20));

  /** Dark color → -25% */
  darkColor = computed(() => this.adjust(this.color(), -40));
}
